import { useWallet } from '@tronweb3/tronwallet-adapter-react-hooks';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { AdapterState } from '@tronweb3/tronwallet-abstract-adapter';
import { ReactPortal } from './ReactPortal.js';
import { WalletItem } from '../WalletItem.js';
export const WalletSelectModal = function ({ visible, onClose }) {
    const nodeRef = useRef(null);
    const { wallets, select } = useWallet();
    const [fadeIn, setFadeIn] = useState(false);
    const [render, setRender] = useState(false);
    const walletsList = useMemo(() => [
        ...wallets.filter((a) => a.state !== AdapterState.NotFound),
        ...wallets.filter((a) => a.state === AdapterState.NotFound),
    ], [wallets]);
    const onWalletClick = useCallback((wallet) => {
        select(wallet.adapter.name);
        onClose();
    }, [select, onClose]);
    function show() {
        setRender(true);
        setFadeIn(true);
    }
    function close() {
        setFadeIn(false);
        // setRender(false)
        setTimeout(() => setRender(false), 200);
    }
    useEffect(function () {
        if (visible) {
            show();
        }
        else {
            close();
        }
    }, [visible]);
    useEffect(() => {
        const closeOnEscapeKey = (e) => (e.key === 'Escape' ? onClose() : null);
        document.body.addEventListener('keydown', closeOnEscapeKey);
        return () => {
            document.body.removeEventListener('keydown', closeOnEscapeKey);
        };
    }, [onClose]);
    return render ? (React.createElement(ReactPortal, { wrapperId: "react-portal-modal-container" },
        React.createElement("div", { "data-testid": "wallet-select-modal", ref: nodeRef, className: `adapter-modal ${fadeIn && 'adapter-modal-fade-in'}` },
            React.createElement("div", { className: "adapter-modal-wrapper" },
                React.createElement("div", { className: "adapter-modal-header" },
                    React.createElement("button", { onClick: onClose, className: "close-button", tabIndex: 0 }),
                    React.createElement("div", { className: "adapter-modal-title" },
                        "Connect a wallet on",
                        React.createElement("br", null),
                        "Tron to continue")),
                React.createElement("div", { className: "adapter-list" }, walletsList.map((wallet) => (React.createElement(WalletItem, { key: wallet.adapter.name, wallet: wallet, onClick: () => onWalletClick(wallet) })))))))) : null;
};
//# sourceMappingURL=WalletSelectModal.js.map